import React from 'react';
import PropTypes from 'prop-types';

import styles from './loader.module.scss';

const Loader = React.memo(({ children, alignPageCenter, justifyCenter, small }) => {
	return (
		<div className={`${styles.default} ${alignPageCenter ? styles.alignPageCenter : ''} ${justifyCenter ? styles.justifyCenter : ''}`}>
			<img src={`/${small ? 'loader-v2-small.svg' : 'loader-v2.svg'}`} style={{ width: small ? 35 : 150, height: small ? 35 : 150 }} title="Loading ..." alt="Loading content ..." />
			{children && <p>{children}</p>}
		</div>
	);
});

Loader.defaultProps = {
	children: null,
	alignPageCenter: false,
	justifyCenter: true,
	small: false
};

Loader.propTypes = {
	children: PropTypes.node,
	alignPageCenter: PropTypes.bool,
	justifyCenter: PropTypes.bool,
	small: PropTypes.bool
};

export default Loader;
